export type ServicePhase = {
  n: number;
  title: string;
  sub: string;
  desc: string;
  items: string[];
};

export const SERVICE_PHASES: ServicePhase[] = [
  {
    n: 1,
    title: "找房",
    sub: "Search",
    desc: "了解你的预算、偏好与时间窗口,从已合作的持牌中介池中筛选可靠房源。",
    items: [
      "1对1偏好调研(30分钟)",
      "排除二房东、违建、可疑挂牌",
      "首批5–8套候选房源 + 利弊点评",
      "支持随时增删条件",
    ],
  },
  {
    n: 2,
    title: "看房",
    sub: "Viewing",
    desc: "管家替你视频实地看房——你能看到的,我们都给你看到。",
    items: [
      "微信视频实时连线,房间每个角落",
      "替你问中介:噪音 / 漏水 / 楼上是否吵",
      "拍下水表电表、家电品牌、门锁",
      "完整看房纪要PDF给你存档",
    ],
  },
  {
    n: 3,
    title: "签约",
    sub: "Contract",
    desc: "新加坡的租房合同条款不少坑,我们逐条翻译,把关条款。",
    items: [
      "全文中文翻译 + 重点条款圈出",
      "Diplomatic Clause(留学生退租条款)必须有",
      "Inventory List拍照存档,避免押金扣项",
      "陪同签约 / 远程见证签字",
    ],
  },
  {
    n: 4,
    title: "退租",
    sub: "Move-out",
    desc: "毕业 / 换房时帮你拿回押金——这一步最容易被坑。",
    items: [
      "提前1个月协助通知房东",
      "陪同验房,争议项现场拍证据",
      "代为追讨押金,处理争议项",
      "如有纠纷,合作律师免费咨询",
    ],
  },
];

export const PRICING_BULLETS = [
  "包含找房 → 订房 → 签约 → 退房全流程服务",
  "包含1次免费陪同换房(同一学年内)",
  "不含房源自带中介费(由中介规则决定,可代为协商)",
  "1对1专属管家,为你的新加坡生活提供全年保障",
] as const;
